import React, { Fragment } from 'react';
import FormGrupoImposto from '../../../components/grupo-imposto/form-grupo-imposto';
import NavBar from '../../../components/layout/navbar/index';

export default function GrupoImposto(props) {
    const grupoImpostoTemp = props.location.state.registroUnico;
    return (
        <Fragment>
            <NavBar />
            <FormGrupoImposto grupoImposto={grupoImpostoTemp} />
        </Fragment>
    )
}